import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"
import _imports_0 from '../assets/img/icon-enterprisereports.svg'
import _imports_1 from '../assets/img/icon-storelogin.svg'


const _hoisted_1 = { class: "flex flex-column align-items-center w-full gap-3 surface-border" }
const _hoisted_2 = { class: "white-space" }
const _hoisted_3 = {
  key: 0,
  class: "ent-items"
}
const _hoisted_4 = { class: "content primary auth" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "Enterprise Reports"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
      /*#__PURE__*/_createElementVNode("h2", null, "Enterprise Reports")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "prose" }, [
      /*#__PURE__*/_createElementVNode("p", null, [
        /*#__PURE__*/_createTextVNode("Reporting for all of your stores' core KPIs"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode("and metrics.")
      ])
    ])
  ])
], -1)
const _hoisted_6 = { class: "content secondary auth" }
const _hoisted_7 = { class: "item" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "Store Login"
  })
], -1)
const _hoisted_9 = { class: "content" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Store Login")
], -1)
const _hoisted_11 = { class: "prose" }
const _hoisted_12 = { class: "lead text-muted" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("strong", null, "Store:", -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode()

import { useAuth0 } from "@auth0/auth0-vue";
import { ref, onMounted } from "vue";
import ApiService from "@/service/api.service";
import ErrorModal from '../views/ErrorModal.vue';
import { openErrorModal } from '@/composables/useErrorLog';
import EnterpriseStoreError from "./EnterpriseStoreError.vue";
import { useStore } from "vuex";
import { useToast } from 'primevue/usetoast';
import { useConfirm } from "primevue/useconfirm";
import { MutationTypes } from "../store/mutations";


export default /*#__PURE__*/_defineComponent({
  name: 'EnterpriseHome',
  setup(__props) {

const confirm = useConfirm();
const enterprisestoreerror = ref(false);
const { isAuthenticated, user, getAccessTokenSilently } = useAuth0();
const store = useStore();
const loading = ref(false);
const enterprisestores = ref([]);
const selectedEnterpriseStore = ref();
const storeid = ref('');
const toast = useToast();

onMounted(async() => {
    const enterpriseid = store.state.enterpriseid;
    const accessToken = await getAccessTokenSilently();
    await ApiService.getEnterpriseStores(accessToken, enterpriseid);
    storeid.value = store.state.storeid;
    enterprisestores.value = store.state.enterprisestores;
    selectedEnterpriseStore.value = enterprisestores.value.find(item => item.StoreId == storeid.value);
});

const updateEnterpriseStore = () => {
    confirm.require({
        group: 'templating',
        header: 'Please confirm store change',
        message: 'Confirm the availability of the store in the Available Enterprise Store list. \nDo you wish to change to the selected store?',
        icon: 'pi pi-exclamation-circle',
        acceptIcon: 'pi pi-check',
        rejectIcon: 'pi pi-times',
        rejectClass: 'p-button-outlined p-button-sm',
        acceptClass: 'p-button-sm btn-primary',
        rejectLabel: 'Cancel',
        acceptLabel: 'Continue',
        accept: async () => {
          loading.value = true;
          const { StoreId, StoreName } = selectedEnterpriseStore.value;
          const userid = user.value.sub;
          const userdata = { storeid: StoreId };
          try {
            const accessToken = await getAccessTokenSilently();
            const response = await fetch(process.env.VUE_APP_NODEJS_BASE_URL + "enterprises/users/" + userid,  {
              method: 'PATCH',
              headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(userdata),
            });

            const data = await response.json();
            loading.value = false;
            if (response.status > 400) {
              throw new Error(JSON.stringify(data.error));
            }
            toast.add({ severity: 'success', summary: 'Changed successfully', detail: `You can now view ${StoreName}.`, life: 3000 });
            localStorage.setItem('storeid', StoreId);
            store.commit(MutationTypes.SET_STOREID, StoreId);
            
            return data.message;
          } catch (e) {
            openErrorModal(e.message);
          }
        },
        reject: () => {
          toast.add({ severity: 'error', summary: 'Rejected', detail: 'Enterprise store change cancelled.', life: 3000 });
        }
    });
};

const storeLogin = () => {
    store.commit(MutationTypes.SET_ISSTORELOGIN, true);
}

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_Card = _resolveComponent("Card")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ErrorModal),
    _createVNode(_component_Toast),
    _createVNode(_component_ConfirmDialog, { group: "templating" }, {
      message: _withCtx((slotProps) => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("p", _hoisted_2, _toDisplayString(slotProps.message.message), 1)
        ])
      ]),
      _: 1
    }),
    (_unref(isAuthenticated))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, { to: { name: 'enterprise', params: { url: '/enterprise' }} }, {
              default: _withCtx(() => [
                _createVNode(_component_Card, null, {
                  content: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Card, null, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("p", _hoisted_12, [
                        _hoisted_13,
                        _createVNode(_component_Dropdown, {
                          disabled: loading.value,
                          modelValue: selectedEnterpriseStore.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedEnterpriseStore).value = $event)),
                          filter: "",
                          options: enterprisestores.value,
                          optionLabel: "StoreName",
                          placeholder: selectedEnterpriseStore.value ? selectedEnterpriseStore.value.StoreName : 'Select an Enterprise store',
                          class: "storeChange",
                          onChange: updateEnterpriseStore
                        }, null, 8, ["disabled", "modelValue", "options", "placeholder"]),
                        _hoisted_14,
                        _createVNode(_component_Button, {
                          label: "Login",
                          class: "logout p-button-rounded btn-secondary sml",
                          onClick: storeLogin
                        })
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(isAuthenticated) && enterprisestoreerror.value)
      ? (_openBlock(), _createBlock(EnterpriseStoreError, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})